import React, { Component } from "react";
import MenuBar from "../common/MenuPanel";
import FooterPanel from "../common/FooterPanel";
import confessionGuide from "../../attachments/CONFESSION_GUIDE_ENGLISH.pdf";
import confessionGuideMal from "../../attachments/CONFESSION_GUIDE_MALAYALAM.pdf";

class ConfessionPage extends Component {
  render() {
    return (
      <React.Fragment>
        {/* Menu */}
        <div className="container-fluid position-relative p-0">
          <MenuBar />
        </div>

        {/* Title Section with Overlay */}
        <section className="container-fluid p-0">
          <div
            className="banner-image_sm"
            style={{
              backgroundImage: `url(${process.env.PUBLIC_URL}/images/2.png)`,
            }}
          >
            <div className="banner-heading text-center wow fadeInDown">
              <h1 className="text-white">Guide to Confession</h1>
            </div>
          </div>
        </section>

        {/* Main Content */}
        <main className="prayers-content container mt-3">
          {/* Prayer Before Confession */}
          <section className="prayer-intro align-items-center">
            <h2 className="text-primary text-center">
              Prayer Before Confession
            </h2>
            Before approaching the Sacrament of Reconciliation, let us ask the
            Holy Spirit for guidance, that we may recognize our sins and
            approach the Lord with a humble heart.
            <blockquote className="scripture-quote">
              <strong><i> 
                “If we say that we have no sin, we deceive ourselves, and the
                truth is not in us. If we confess our sins, He who is faithful
                and just will forgive us our sins and cleanse us from all
                unrighteousness.” (1 John 1:8-9)
              </i></strong>
            </blockquote>
            <p className="indented-text">
              <strong>Come, Holy Spirit</strong>, into my soul. Enlighten my
              mind that I may know the sins I ought to confess, and grant me the
              grace to confess them fully, humbly, and with a contrite heart.
              Help me to firmly resolve not to commit them again.
              <strong>O Blessed Virgin, Mother of my Redeemer</strong>,
              intercede for me through the Passion of Your Son, that I may
              obtain the grace to make a good confession.
              <strong>All you blessed Angels and Saints of God</strong>, pray
              for me, a sinner, that I may repent from my sins and that my heart
              may be forever united with yours in eternal love. Amen.
            </p>
          </section>

          {/* Preparing for Confession */}
          <section className="mt-0">
            <h3 className="text-secondary text-center">
              Preparing for Confession
            </h3>
            The Church encourages us to examine our conscience thoroughly before
            going to Confession. This reflection allows us to acknowledge our
            sins and approach God’s mercy with sincerity.
          </section>

          {/* Examination of Conscience */}
          <section className="mt-0">
            <h3 className="text-secondary text-center">
              Examination of Conscience
            </h3>
            Below is a guide to the Sacrament of Reconciliation, including a
            detailed <strong>Examination of Conscience</strong> based on
            Scripture.
          </section>

          {/* Download Links */}
          <section className="text-center mt-1">
            <div className="d-flex justify-content-center gap-3 mb-3">
              <a
                href={confessionGuide}
                download="Guide_to_Confession_English.pdf"
                className="download-link"
                aria-label="Download Confession Guide in English"
              >
                <button className="download-button  mb-3">
                  📖 Download Confession Guide: English
                </button>
              </a>
              <span>&nbsp;</span>
              <a
                href={confessionGuideMal}
                download="Guide_to_Confession_Malayalam.pdf"
                className="download-link"
                aria-label="Download Confession Guide in Malayalam"
              >
                <button className="download-button  mb-3">
                  📖 Download Confession Guide: Malayalam
                </button>
              </a>
              <br />
            </div>
          </section>
        </main>

        {/* Footer */}
        <FooterPanel />
      </React.Fragment>
    );
  }
}

export default ConfessionPage;
